import { FC } from "react";
import { Modal, Header, SpaceBetween, Link } from "@cloudscape-design/components";
import CodeBrokkrIFrame from "..";

interface CodeBrokkrModalProps {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
}

const CodeBrokkrModal: FC<CodeBrokkrModalProps> = ({ isOpen, setIsOpen }) => {
  const url = process.env.REACT_APP_CODE_BROKKR_APP_URL;

  if (url === undefined) return (
    <Modal visible={isOpen} onDismiss={() => setIsOpen(false)}>
      <span>
        <code>REACT_APP_CODE_BROKKR_APP_URL</code> is not defined.
      </span>
    </Modal>
  );

  const header = (
    <Header variant='h3' actions={
      <Link external href={`${url}/builder`} variant='primary'>Open In New Tab</Link>
    }>
      Provision Application Repository with Code Brokkr
    </Header>
  );

  return (
    <Modal
      visible={isOpen}
      disableContentPaddings={true}
      header={header}
      onDismiss={() => {
        setIsOpen(false)
      }}
      size="max"
    >
      <div style={{ display: 'flex', minHeight: '80svh' }}>
        <CodeBrokkrIFrame iframeTitle='Code Brokkr' iframeUrl={`${url}/builder`}/>
      </div>
    </Modal>
  )
};

export default CodeBrokkrModal;